import {
    insightAreaApplyFilterCriteria,
    insightAreaClearFilterCriteria,
    insightAreaSetFilter
} from "../../../actions/insight-area-actions"

import buildFilterWidgetContainer from "../../common/build-filter-widget-container"

import InsightAreaListFilterFormContainer from "./InsightAreaListFilterFormContainer"

export default buildFilterWidgetContainer(
    InsightAreaListFilterFormContainer,
    insightAreaClearFilterCriteria,
    insightAreaApplyFilterCriteria,
    insightAreaSetFilter
)
